import { render, staticRenderFns } from "./CallToActionSection.vue?vue&type=template&id=323fd0e0"
import script from "./CallToActionSection.vue?vue&type=script&lang=js"
export * from "./CallToActionSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports